import { FeeType, SaleGetAllQuery } from '../../types';

export const getNotFoundSales = (
  data: SaleGetAllQuery,
  containerList: string[] | string,
): SaleGetAllQuery => {
  if (typeof containerList === 'string' || !containerList) return data;

  const notFound = containerList.filter(
    (number) => !data.data.some((item) => item.number === number),
  );

  const result = [
    ...data.data,
    ...notFound.map((number) => ({
      number,
      id: '',
      clientYardId: '',
      type: undefined as any,
      canTrade: true,
      status: 'NOT_FOUND' as any,
      images: [],
      documents: [],
      clientYard: { client: { code: '', id: '' }, yard: { id: '', address: '', name: '' } },
      gateIn: { driver: { licensePlateNumber: '' }, completedAt: '' },
      gateOut: { completedAt: '', status: 'ACTIVE' as any },
      _count: { repair: 0 },
      sale: {
        status: 'NOT_FOUND' as const,
        forSaleDate: '',
        ownerSetPrice: 0,
        finalPrice: 0,
        allowCounterOffers: false,
        description: '',
        createdByName: '',
        feeType: FeeType.PERCENTAGE,
        feeValue: 0,
      },
      isMyContainer: false,
    })),
  ];

  return { data: result, totalCount: result.length };
};
